// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProcessor } from './PaymentProcessor';
import {
  PaymentProcessorFromJSON,
  PaymentProcessorFromJSONTyped,
  PaymentProcessorToJSON,
  PaymentProcessorToJSONTyped,
} from './PaymentProcessor';

/**
 *
 * @export
 * @interface GetPaymentProcessorResponse
 */
export interface GetPaymentProcessorResponse {
  /**
   *
   * @type {PaymentProcessor}
   * @memberof GetPaymentProcessorResponse
   */
  paymentProcessor?: PaymentProcessor;
}

/**
 * Check if a given object implements the GetPaymentProcessorResponse interface.
 */
export function instanceOfGetPaymentProcessorResponse(
  value: object,
): value is GetPaymentProcessorResponse {
  return true;
}

export function GetPaymentProcessorResponseFromJSON(
  json: any,
): GetPaymentProcessorResponse {
  return GetPaymentProcessorResponseFromJSONTyped(json, false);
}

export function GetPaymentProcessorResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetPaymentProcessorResponse {
  if (json == null) {
    return json;
  }
  return {
    paymentProcessor:
      json['paymentProcessor'] == null
        ? undefined
        : PaymentProcessorFromJSON(json['paymentProcessor']),
  };
}

export function GetPaymentProcessorResponseToJSON(
  json: any,
): GetPaymentProcessorResponse {
  return GetPaymentProcessorResponseToJSONTyped(json, false);
}

export function GetPaymentProcessorResponseToJSONTyped(
  value?: GetPaymentProcessorResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    paymentProcessor: PaymentProcessorToJSON(value['paymentProcessor']),
  };
}
